export const API_HOST =
  process.env.API_HOST || 'https://ca-api-services-stg.wittystone-756736e6.eastus2.azurecontainerapps.io'
export const LEGACY_API_HOST = process.env.LEGACY_API_HOST || 'https://secure-payk12-staging.azurewebsites.net'
export const APP_HOST = process.env.APP_HOST || process.env.NEXT_PUBLIC_APP_HOST || 'http://localhost:3000'
export const SECURITY_SECRET =
  process.env.SECURITY_SECRET ||
  'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
export const SECURITY_ISSUER = process.env.SECURITY_ISSUER || 'https://secure.payk12.com/'
export const SECURITY_AUDIENCE = process.env.SECURITY_AUDIENCE || 'https://secure.payk12.com/'
export const CAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY || '6LcnxFkfAAAAALBl241k-nFsMOgDXq1s5iBcr0UJ'
export const FINGERPRINT_SDK_KEY = process.env.NEXT_PUBLIC_FINGERPRINT_SDK_KEY || ''
/** Best-effort overlay lookup; a hung Platform call must not stall /auth/session. */
export const IMPERSONATION_STATE_TIMEOUT_MS = Number(process.env.IMPERSONATION_STATE_TIMEOUT_MS || 2000)
/** Legacy UserCheck() AJAX timeout. Keep in sync with AUTH_SESSION in public-header.js. */
export const USER_CHECK_TIMEOUT_MS = Number(process.env.USER_CHECK_TIMEOUT_MS || 8000)
export const AUTH_SESSION_PATH = '/auth/session'

export default {
  API_HOST,
  LEGACY_API_HOST,
  APP_HOST,
  SECURITY_SECRET,
  SECURITY_ISSUER,
  SECURITY_AUDIENCE,
  CAPTCHA_SITE_KEY,
  FINGERPRINT_SDK_KEY,
  IMPERSONATION_STATE_TIMEOUT_MS,
  USER_CHECK_TIMEOUT_MS,
  AUTH_SESSION_PATH,
} as const
